/**
 * NetworkStatus - UI индикатор состояния сети
 */
import { useEffect, useState, memo } from 'react'
import { NetworkManager, type NetworkStatus as NetworkStatusType } from '../services/networkManager'
import './NetworkStatus.css'

export const NetworkStatus = memo(function NetworkStatus() {
  const [status, setStatus] = useState<NetworkStatusType>(NetworkManager.getStatus())
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Подписываемся на изменения статуса
    const unsubscribe = NetworkManager.subscribe((newStatus) => {
      setStatus(newStatus)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    // Показываем индикатор только при офлайне или проверке
    if (status === 'offline') {
      setIsVisible(true)
    } else if (status === 'online') {
      // Скрываем с задержкой после восстановления связи
      const timer = setTimeout(() => {
        setIsVisible(false)
      }, 2000) // Показываем "Связь восстановлена" 2 секунды
      return () => clearTimeout(timer)
    } else {
      setIsVisible(false)
    }
  }, [status])

  if (!isVisible && status !== 'checking') {
    return null
  }

  const getStatusInfo = () => {
    switch (status) {
      case 'offline':
        return {
          className: 'network-status--offline',
          icon: '📡',
          message: 'Нет интернета',
          submessage: 'Ожидаем подключение... Проверка каждые 30 секунд',
        }
      case 'checking':
        return {
          className: 'network-status--checking',
          icon: '🔄',
          message: 'Проверка подключения...',
          submessage: null,
        }
      case 'online':
        return {
          className: 'network-status--online',
          icon: '✅',
          message: 'Связь восстановлена',
          submessage: 'Синхронизация данных...',
        }
    }
  }

  const statusInfo = getStatusInfo()

  return (
    <div className={`network-status ${statusInfo.className}`}>
      <div className="network-status__content">
        <span className="network-status__icon">{statusInfo.icon}</span>
        <div className="network-status__text">
          <div className="network-status__message">{statusInfo.message}</div>
          {statusInfo.submessage && (
            <div className="network-status__submessage">{statusInfo.submessage}</div>
          )}
        </div>
      </div>
    </div>
  )
})

